import services from '../services'
import * as types from './mutation-types'

export const getAll = ({ commit }, params) => (
  services.list(params).then(res => {
    commit(types.SET_HOTEL_ALLOCATIONS, res.data)
  })
)

export const getAllocation = async ({ commit }, id) => {
  await services.show(id).then(res => {
    commit(types.SET_HOTEL_ALLOCATION, res.data.data)
  })
}

export const save = async ({ commit }, obj) => {
  await services.saveAllocation(obj).then(res => {
    commit(types.SET_HOTEL_ALLOCATION, res.data.data)
    return res
  })
}

export const saveAll = async ({ commit }, obj) => {
  await services.postAllData(obj).then(res => {
    return res
  })
}

export const deleteAllocation = async ({ commit }, id) => {
  await services.delAllocation(id).then(res => {
    return res
  })
}
